var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.2262 11.3281H17.7738C14.2295 11.3281 11.3281 14.2295 11.3281 17.7738V69.3359C11.3281 72.8793 14.2295 75.7816 17.7738 75.7816H46.7777V82.2262H37.1097C33.5499 82.2262 30.6641 85.1093 30.6641 88.6719L69.3359 88.6651C69.3359 85.1093 66.4501 82.2204 62.8903 82.2204H53.2223V75.7816H82.2262C85.7705 75.7816 88.6719 72.8793 88.6719 69.3359V17.7738C88.6719 14.2295 85.7705 11.3281 82.2262 11.3281ZM37.5816 51.4164L34.1638 54.834L25.162 45.8331C23.9033 44.5735 23.9033 42.5345 25.162 41.2756L34.1638 32.2748L37.5814 35.6924L29.7195 43.5534L37.5816 51.4164ZM49.2545 58.0563H44.2978L50.7462 29.0524H55.703L49.2545 58.0563ZM74.8371 45.8331L65.8362 54.834L62.4186 51.4164L70.2806 43.5544L62.4186 35.6933L65.8362 32.2757L74.838 41.2765C76.0958 42.5287 76.0958 44.5744 74.8371 45.8331Z",
    fill: "url(#paint0_linear_4_51842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_51842",
    x1: 13.1802,
    y1: 11.3281,
    x2: 86.8198,
    y2: 88.6719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossPlatform);
export default __webpack_public_path__ + "static/media/Cross-Platform.8811cd15d3fe4e661d1ee1bad8fb3069.svg";
export { ForwardRef as ReactComponent };